<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="inventory-drawer"
      title="Inventory Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in filteredTabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in filteredTabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconBox,
  BIconClipboard,
  BIconArchive,
  BIconTruck,
  BIconFileText
} from "bootstrap-vue";

import InventoryByLocation from "@/components/Inventory/InventoryByLocation";
import LookupInventory from "@/components/Inventory/LookupInventory";
import InventoryMoveLogs from "@/components/Inventory/InventoryMoveLogs";
import AddInventory from "@/components/Inventory/AddInventory";
import OutOfStockProducts from "@/components/Inventory/OutOfStockProducts.vue";
import DamagesManagement from "@/components/Inventory/DamagesManagement.vue";
import NonInventoryItems from "@/components/Inventory/NonInventoryItems.vue";

export default {
  name: "InventoryMain",
  components: {
    AddInventory,
    InventoryByLocation,
    LookupInventory,
    InventoryMoveLogs,
    DamagesManagement,
    OutOfStockProducts,
    NonInventoryItems,

    // icons
    BIconList,
    BIconBox,
    BIconClipboard,
    BIconArchive,
    BIconTruck,
    BIconFileText
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
        {
          title: "ADD INVENTORY",
          icon: "box",
          roles: ["admin", "officemanager"],
          component: "AddInventory"
        },
        {
          title: "INVENTORY (BY LOCATION)",
          icon: "file-text",
          roles: [
            "admin","officeuser","officemanager","locationadmin",
            "locationstockperson","salesperson","warehouseuser",
            "warehousemanager","accountuser"
          ],
          component: "InventoryByLocation"
        },
        {
          title: "PRODUCT INVENTORY LOOKUP",
          icon: "file-text",
          roles: [
            "admin","officeuser","officemanager","locationadmin",
            "locationstockperson","salesperson","warehouseuser",
            "warehousemanager","accountuser"
          ],
          component: "LookupInventory"
        },
        {
          title: "INVENTORY MOVE LOGS",
          icon: "clipboard",
          roles: ["admin","officeuser","officemanager","warehouseuser","warehousemanager"],
          component: "InventoryMoveLogs"
        },
        {
          title: "AS IS INVENTORY",
          icon: "archive",
          roles: [
            "admin","officeuser","officemanager","locationadmin",
            "locationstockperson","salesperson","warehouseuser",
            "warehousemanager","accountuser"
          ],
          component: "DamagesManagement"
        },
        {
          title: "OUT OF STOCK PRODUCTS",
          icon: "archive",
          roles: [
            "admin","officeuser","officemanager","locationadmin",
            "locationstockperson","salesperson","warehouseuser",
            "warehousemanager","accountuser"
          ],
          component: "OutOfStockProducts"
        },
          {
        title: "NON-INVENTORY ITEMS",
        icon: "file-text",
        roles: [
            "admin", "officeuser", "officemanager", "locationadmin",
            "locationstockperson", "salesperson", "warehouseuser",
            "warehousemanager", "accountuser"
        ],
        component: "NonInventoryItems"
    },
      ]
    };
  },

  computed: {
    filteredTabs() {
      const role = this.packet.userDetails.userrole || "";
      return this.tabs.filter(tab => tab.roles.includes(role));
    },
    activeTabTitle() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.filteredTabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");
      } catch (err) {
        console.error("Error parsing user data:", err);
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inventory/InventoryMain.vue